import { apiRequest } from "@nusrif/utils";
import { GenerateAddFavoriteParams, GetFavoritesResponse } from "@nusrif/types";

/**
 * Adds a product to the user's favorites.
 * @param favorite - The favorite object containing userId and productId.
 * @returns A promise that resolves to the response containing the list of favorites.
 */
export async function addFavorite(favorite: GenerateAddFavoriteParams): Promise<GetFavoritesResponse> {
  return apiRequest<GetFavoritesResponse>('/favorites', {
    method: 'POST',
    body: favorite,
  });
}

/**
 * Retrieves the list of favorites for a user.
 * @param userId - The ID of the user whose favorites are to be retrieved.
 * @returns A promise that resolves to the response containing the list of favorites.
 */
export async function getFavorites(): Promise<GetFavoritesResponse> {
  return apiRequest<GetFavoritesResponse>('/favorites', {
    method: 'GET',
  });
}

/**
 * Removes a product from the user's favorites.
 * @param favoriteId - The ID of the favorite to be removed.
 * @returns A promise that resolves to the response containing the updated list of favorites.
 */
export async function removeFavorite(userId: string, productId: number): Promise<GetFavoritesResponse> {
  return apiRequest<GetFavoritesResponse>(`/favorites/`, {
    method: 'DELETE',
    body: { userId, productId },
  });
}

/**
 * Removes all favorites for a user.
 * @param favoriteId - The ID of the favorite to be removed.
 * @returns A promise that resolves to the response containing the updated list of favorites.
 */
export async function removeAllUsersFavorite(userId: string): Promise<GetFavoritesResponse> {
  return apiRequest<GetFavoritesResponse>(`/favorites/${userId}`, {
    method: 'DELETE',
  });
}